import Form from 'flarum/common/components/Form';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import FormModal from 'flarum/common/components/FormModal';
import username from 'flarum/common/helpers/username';
import Stream from 'flarum/common/utils/Stream';
import withAttr from 'flarum/common/utils/withAttr';
export default class ActionModal extends FormModal {
  oninit(vnode) {
    super.oninit(vnode);
    this.request = this.attrs.request;
    this.approved = Stream('Rejected');
    this.reason = Stream('');
    this.translationPrefix = "fof-username-request.forum.".concat(this.request.forNickname() ? 'nickname' : 'username', "_modals.action");
  }
  title() {
    return app.translator.trans("".concat(this.translationPrefix, ".title"));
  }
  className() {
    return 'RequestActionModal Modal--medium';
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, null, m("h3", {
      className: "Notification-content"
    }, app.translator.trans("".concat(this.translationPrefix, ".name"), {
      name: username(this.request.user()),
      requestedName: this.request.requestedUsername()
    })), m("p", {
      className: "help"
    }, app.translator.trans("".concat(this.translationPrefix, ".help_text"))), m("legend", null, app.translator.trans("".concat(this.translationPrefix, ".decision_title"))), m("div", {
      className: "Form-group"
    }, m("label", {
      className: "checkbox"
    }, m("input", {
      type: "radio",
      name: "approved",
      value: "Approved",
      checked: this.approved() === 'Approved',
      onclick: withAttr('value', this.approved)
    }), app.translator.trans("".concat(this.translationPrefix, ".approval_label"))), m("label", {
      className: "checkbox"
    }, m("input", {
      type: "radio",
      name: "rejected",
      value: "Rejected",
      checked: this.approved() === 'Rejected',
      onclick: withAttr('value', this.approved)
    }), app.translator.trans("".concat(this.translationPrefix, ".rejected_label")))), this.approved() === 'Rejected' ? m("div", {
      className: "Form-group"
    }, m("legend", null, app.translator.trans("".concat(this.translationPrefix, ".reason_title"))), m("div", {
      className: "BasicsPage-reason-input"
    }, m("textarea", {
      className: "FormControl",
      value: this.reason(),
      disabled: this.loading,
      oninput: withAttr('value', this.reason)
    }))) : '', m("div", {
      className: "Form-group"
    }, Button.component({
      className: 'Button Button--primary Button--block',
      type: 'submit',
      loading: this.loading,
      disabled: this.approved() === 'Rejected' && !this.reason() ? true : false
    }, app.translator.trans("".concat(this.translationPrefix, ".submit_button"))))));
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    this.request.save({
      reason: this.reason(),
      status: this.approved()
    }).then(() => {
      this.successAlert = app.alerts.show({
        type: 'success'
      }, app.translator.trans("".concat(this.translationPrefix, ".success")));
      // Remove from cache so it disappears from the dropdown
      if (app.cache.username_requests) {
        const idx = app.cache.username_requests.findIndex(r => r.id() === this.request.id());
        if (idx !== -1) {
          app.cache.username_requests.splice(idx, 1);
        }
      }
      m.redraw();
    }).catch(() => {}).then(() => this.hide());
  }
}
flarum.reg.add('fof-username-request', 'forum/components/ActionModal', ActionModal);